/* unplugin-vue-components disabled */import script from "./DetailIosTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailIosTable.vue?vue&type=script&lang=ts&setup=true"

import "./DetailIosTable.vue?vue&type=style&index=0&id=63f23620&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f23620"]])

export default __exports__